module.exports = " <li class=vux-timeline-item> <div :class=\"['vux-timeline-item-color', {'vux-timeline-item-head': !isFirst,'vux-timeline-item-head-first': isFirst }]\" :style=headStyle> <icon v-show=isFirst type=success_no_circle class=vux-timeline-item-checked></icon> </div> <div class=vux-timeline-item-tail :style=tailStyle></div> <div class=vux-timeline-item-content> <slot></slot> </div> </li> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/timeline/timeline-item.vue
// module id = 256
// module chunks = 2